import React from "react";
import styles from "./header.module.css";
import { Link } from "react-router-dom";

const HeaderCompNew = () => {
  return (
    <header className={styles.topBar}>
      <h1 className={styles.logo}>spoti-stats</h1>
      <Link
        to="/nowplaying"
        className={`${styles.nowPlayingBtn} ${styles.Link}`}
      >
        <button className={`${styles.Btn}`}>now playing</button>
      </Link>
      <Link to="/toptracks" className={`${styles.topTracksBtn} ${styles.Link}`}>
        <button className={`${styles.Btn}`}>top tracks</button>
      </Link>
      <Link
        to="/topartists"
        className={`${styles.topArtistsBtn} ${styles.Link}`}
      >
        <button className={`${styles.Btn}`}>top artists</button>
      </Link>
      <Link
        to="/createplaylists"
        className={`${styles.createPlaylistsBtn} ${styles.Link}`}
      >
        <button className={`${styles.Btn}`}>create playlists</button>
      </Link>

      <button
        className={styles.logInBtn}
        onClick={() =>
          (window.location = "https://spotistats-auth.herokuapp.com/login")
        }
      >
        Log in with Spotify
      </button>
    </header>
  );
};

export default HeaderCompNew;
